<template>
    <div class="setRole">
        <z-title title="角色管理" ref="title"></z-title>
        <el-card class="content1" ref="search">
            <div class="flex-n fac fjb ">

            <div class="flex-n fac">
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        maxlength="20"
                        placeholder="输入角色名称"
                        title="输入角色名称"
                        clearable
                        prefix-icon="el-icon-search"
                        v-model="roleName">
                </el-input>
            </div>
            <div class="flex-n fac">
                <el-button type="primary" class="ele-btn2" @click="searchList">查询</el-button>
                <el-button type="primary" class="ele-btn1" @click="addRole">新增角色</el-button>
            </div>
            </div>
        </el-card>
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    element-loading-spinner="el-icon-loading"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        prop="roleName"
                        fixed
                        label="角色名称"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="roleState"
                        label="状 态"
                >
                    <template slot-scope="scope">
                        {{scope.row.roleState==0?'停用':'启用'}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备 注"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="160"
                        align="center">
                    <template slot-scope="scope">
                        <div style="margin: 5px 0">
                            <el-button type="primary" class="ele-btn-small" @click="editRole(scope.row.id)">编辑</el-button>
                            <el-button type="primary" class="ele-btn-small" @click="editJurisdiction(scope.row.id)">权限</el-button>

                                <el-popconfirm
                                    :title="'确定删除该角色吗？'"
                                    @onConfirm="delRole(scope.row.id)"
                                    class="ml-10"
                            >
                                <el-button slot="reference" type="primary" class="ele-btn-small">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <!--新增角色-->
        <edit-role :id="id" :visible.sync="showedit" :state="editstate" @refreshList="searchList"></edit-role>
        <!--编辑权限-->
        <edit-jurisdiction :id="id" :visible.sync="showJurisdiction"  @refreshList="searchList"></edit-jurisdiction>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import Pagination from "../../components/pagination/pagination";
    import EditRole from "./sub/EditRole";
    import EditJurisdiction from "./sub/EditJurisdiction";

    export default {
        components: {
            EditJurisdiction,
            EditRole,
            Pagination,
            ZTitle},
        name: "role",
        data() {
            var validatetel = (rule, value, callback) => {
                if(value&&value.length!=11||!value){
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            return {
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height:250,

                editstate: 0,
                showedit: false,

                roleName: '',
                id: '',

                allStoreList: [],
                roleList: [],
                dataList: [],
                showJurisdiction:false,

            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            this.getDataList();
            // this.showAllStoreList(true);
            // this.getRoleList(true);
        },
        methods: {
            //全部店铺
            showAllStoreList(isshow) {
                if (isshow) {
                    this.$axios.post('/store/dropDownBoxAll').then(res => {
                        console.log(res)
                        this.allStoreList = res.data.list;
                    }).catch(err => {
                        this.$message.error(err.msg);
                    })
                }
            },
            //角色列表
            getRoleList(isshow) {
                if (isshow)
                    this.$axios.post("/role/dropDownBoxAll").then(res => {
                        this.roleList = res.data.list;
                    }).catch(err => {
                        this.$message.error(err.msg);
                    })
            },
            editRole(id){
                this.id=id;
                this.editstate = 1;
                this.showedit = true;
            },
            //权限
            editJurisdiction(id){
                this.id=id;
                this.showJurisdiction=true;
            },
            //新增
            addRole() {
                this.showedit = true;
                this.editstate = 0;
            },
            //用户列表接口
            getDataList() {
                this.loading = true;
                this.$axios.post('/role/findAll', {
                    "storeId": this.$root.getStorage('storeId'),
                    "pageNum": this.currentPage,
                    "pageSize": this.pageSize,
                    "RoleName": this.RoleName,
                    "loginName": this.loginName
                }).then(res => {
                    console.log(res)
                    this.dataList = res.data.list;
                    this.total = res.data.total;
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            //搜索
            searchList() {
                this.currentPage = 1;
                this.getDataList();
            },


            //删除
            delRole(id) {
                console.log(id)
                    this.$axios.post('/role/logicDeleteByIds',id).then(res=>{
                        this.$message.success('删除角色成功！');
                        this.getDataList();
                    }).catch(err=>{
                        this.$message.error(err.msg);
                    })
            },



            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pageSize = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.currentPage = val;
                this.getDataList();
            },
        },
    }
</script>

<style scoped lang="scss">
    .setRole {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
    }
</style>